import { render, staticRenderFns } from "./PcClmPrsTable.vue?vue&type=template&id=db268674&"
import script from "./PcClmPrsTable.vue?vue&type=script&lang=js&"
export * from "./PcClmPrsTable.vue?vue&type=script&lang=js&"
import style0 from "./PcClmPrsTable.vue?vue&type=style&index=0&id=db268674&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports